<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" toName="编辑" cneterName="SEO优化" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout2.labelCol"
        :wrapper-col="currentFormLayout2.wrapperCol">
        <a-form-model-item label="页面标题(title)" prop="title">
          <div style="display: flex">
            <a-textarea
              v-model="ruleForm.title"
              placeholder="请输入"
              :rows="8"
              :maxLength="2000"
              style="max-width:500px;flex: 1"/>
            <span style="color: #999;margin-left: 20px;line-height: 20px;">
            可用动态参数：<br>
            {当前城市} 仅支持首页及商品列表页面<br>
            {所在地} 仅支持商品详情页面<br>
            {出发地}  仅支持商品详情页面<br>
            {商品标题}  仅支持商品详情页面<br>
            {商品亮点/介绍标语}  仅支持商品详情页面<br>
          </span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="页面描述(description)" prop="description">
          <div style="display: flex">
            <a-textarea
              v-model="ruleForm.description"
              placeholder="请输入"
              :rows="8"
              :maxLength="2000"
              style="max-width:500px;flex: 1"/>
            <span style="color: #999;margin-left: 20px;line-height: 20px;">
              可用动态参数：<br>
              {当前城市} 仅支持首页及商品列表页面<br>
              {所在地} 仅支持商品详情页面<br>
              {出发地}  仅支持商品详情页面<br>
              {商品标题}  仅支持商品详情页面<br>
              {商品亮点/介绍标语}  仅支持商品详情页面<br>
            </span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="页面关键词(keywords)" prop="keywords">
          <div style="display: flex">
            <a-textarea
              v-model="ruleForm.keywords"
              placeholder="请输入"
              :rows="8"
              :maxLength="2000"
              style="max-width:500px;flex: 1"/>
            <span style="color: #999;margin-left: 20px;line-height: 20px;">
              可用动态参数：<br>
              {当前城市} 仅支持首页及商品列表页面<br>
              {所在地} 仅支持商品详情页面<br>
              {出发地}  仅支持商品详情页面<br>
              多个关键词需以英文 , 间隔<br>
            </span>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'AddSEOptimization',
  components: {
    Breadcrumb
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      ruleForm: {
        title: '',
        description: '',
        keywords: ''
      },
      rules: {
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        description: [{ required: true, message: '请输入', trigger: 'blur' }],
        keywords: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      submitLoading: false
    }
  },
  activated() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      let url = 'pc/v2/seo/' + this.$route.query.id
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.ruleForm.title = res.title
          this.ruleForm.description = res.description
          this.ruleForm.keywords = res.keywords
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    handleOk() {
      let parms = {
        description: this.ruleForm.description,
        keywords: this.ruleForm.keywords,
        title: this.ruleForm.title,
        id: this.$route.query.id
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/seo/save', parms)
        .then(res => {
          this.$message.success('保存成功')
          this.submitLoading = false
          this.goBack()
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>